import { v4 as uuidv4 } from "uuid";
import type { ItemCategory, ItemImage, DayOfWeek } from "@/lib/types";
import type { ResolvedLocationIds } from "@/lib/locationIds";
import {
  emptyFamilySpecs,
  type ListingFamilySpecs,
} from "@/lib/listing/listingFamilyRuntime";

export type SellListingMode = "single" | "bulk";

export const BULK_LISTING_MIN_ITEMS = 2;
export const BULK_LISTING_MAX_ITEMS = 10;

/** Shown when bulk mode has fewer than {@link BULK_LISTING_MIN_ITEMS} items. */
export const BULK_LISTING_MIN_ITEMS_MESSAGE =
  "Bulk listing requires at least 2 items. Use single-item mode to list one item.";

export interface BulkListingCommonState {
  location: string;
  locationIds?: ResolvedLocationIds | null;
  pickupDays: DayOfWeek[];
  pickupStartHour: string;
  pickupEndHour: string;
}

export interface BulkListingItemDraft {
  /** Client-only draft row id (not `listing_batch_id` in the database) */
  id: string;
  title: string;
  description: string;
  defects: string;
  price: string;
  category: ItemCategory | "";
  subcategory: string;
  quantity: number;
  brand: string;
  size: string;
  model: string;
  familySpecs: ListingFamilySpecs;
  images: ItemImage[];
  rulesAcknowledged: boolean;
  /** Set after a failed batch submit for this row */
  submitError?: string;
  /** Set after a successful create in the last batch run */
  lastSubmitSucceeded?: boolean;
}

export function createEmptyBulkItemDraft(): BulkListingItemDraft {
  return {
    id: uuidv4(),
    title: "",
    description: "",
    defects: "",
    price: "",
    category: "" as ItemCategory,
    subcategory: "",
    quantity: 1,
    brand: "",
    size: "",
    model: "",
    familySpecs: emptyFamilySpecs(),
    images: [],
    rulesAcknowledged: false,
  };
}

export function defaultBulkListingCommon(): BulkListingCommonState {
  return {
    location: "",
    pickupDays: [],
    pickupStartHour: "9",
    pickupEndHour: "17",
  };
}
